export default {
  View: "View",
  DeleteView: "DeleteView",
  ViewViewedMeList: "ViewViewedMeList",
  ViewlikedMeList: "ViewlikedMeList",
  ViewchatReadList: "ViewchatReadList",
};
